<template>
  <Widget
    id="news-widget"
    :title="'Panduan'"
    customHeader
    bodyClass="p-0"
    :showLoader="false"
  >
    <ul class="news-list list-group">
      <li class="list-group-item d-flex align-items-center gap-3">
        <span class="icon text-white bg-success">
          <i class="fa fa-book"></i>
        </span>
        <h5 class="name m-0 mb-xs">
          <a href="https://drive.google.com/file/d/16UfybcgoVeHucN_rzKETwYJ1vdKXg5J1/view" target="blank">Manual Book Penggunaan Aplikasi E-Sea</a>
        </h5>
      </li>
      <li class="list-group-item d-flex align-items-center gap-3">
        <span class="icon text-white bg-success">
          <i class="fa fa-book"></i>
        </span>
        <h5 class="name m-0 mb-xs">
          <a href="https://drive.google.com/file/d/18IYRxzzrjLoCOEy_5ea8OFinOHemfHfy/view" target="blank">Buku Saku Laporan Tahunan KKPRL</a>
        </h5>
      </li>
    </ul>
  </Widget>
</template>

<script>
export default {};
</script>

<style src="./Grid.scss" lang="scss" />
